module.exports = __webpack_public_path__ + "img/mercado_libre.49ea83c4.png";